import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import TopupHistoryTable from "./table/topupHistoryTable";

const TopupHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="topuphistory_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Topup History"
      table={<TopupHistoryTable />}
    />
  );
};

export default TopupHistoryPage;
